import { Box, Button, EmptyStates } from '@inflearn/ds-react-next';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

interface ErrorResetBoundaryProps {
  children: ReactNode;
}

/** @see {@link https://tanstack.com/query/v4/docs/framework/react/reference/QueryErrorResetBoundary} */
export const ErrorResetBoundary = ({ children }: ErrorResetBoundaryProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        onReset={reset}
        fallbackRender={({ resetErrorBoundary }) => (
          <ErrorEmptyStates onClick={resetErrorBoundary} />
        )}
      >
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);

const ErrorEmptyStates = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Box my={90}>
      <EmptyStates
        image="ERROR"
        title={t('문제가 발생했어요')}
        body={t('문제가 지속되면 지원팀에 문의해 주세요.')}
        cta={
          <Button variant="default" size="xs" onClick={onClick}>
            {t('다시 불러오기')}
          </Button>
        }
      />
    </Box>
  );
};
